const env = import.meta.env.VITE_APP_ENV as '1' | '3';

//   prod = 1,
//   test = 3, test on number 3 cause we have standart on other
//   project where 1 is prod 2 is stage 3 is testqa (the same as we
//   have on master layout config)

interface IAppConfig {
  clientId: string;
  postLoginLink: string;
  api: string;
  authLink: string;
  /** Application page URL for subscription authorization */
  productPageUrl: string;
  /** Redirect Url in case of subscription authorization fail */
  paywallRedirectUrl: string;
}

export const configObject: { [id: string]: IAppConfig } = {
  '1': {
    clientId: 'locationProfile_prod',
    postLoginLink: 'https://app.cucollaborate.com',
    api: 'https://location-profile.azurewebsites.net',
    authLink: 'https://id.cucollaborate.com',
    productPageUrl: 'https://mapping.cucollaborate.com',
    paywallRedirectUrl:
      'https://app.cucollaborate.com/PaywallPages/Paywall?productId=15',
  },
  '3': {
    clientId: 'locationProfile_test',
    postLoginLink: 'https://testqa.cucollaborate.com',
    api: 'https://location-profile-testqa1.cucollaborate.com',
    authLink: 'https://authtestqa.cucollaborate.com',
    productPageUrl: 'https://mapping.cucollaborate.com',
    paywallRedirectUrl:
      'https://testqa.cucollaborate.com/PaywallPages/Paywall?productId=95',
  },
};

export const appConfig: IAppConfig = configObject[env];
